export const NEW_LINK_ID = 'new';
export const MEETINGS_APP_NAME = 'meetings';
export const MEETINGS_ADMIN_FEATURE = 'meetings-admin';